export default __webpack_public_path__ + "static/media/gallery_00.fc0a289d.jpg";